export { DiagnosticResults } from './DiagnosticResults';
export { PathologyScreen } from './PathologyScreen';
